import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useInquiry } from "@/contexts/InquiryContext";

export default function Hero() {
  const { openInquiry } = useInquiry();
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[92vh] w-full overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="/apartments/image11.jpeg"
          alt="Kenneth Nathanael Lukman LLC luxury London apartment"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 min-h-[92vh] flex flex-col justify-center text-white">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl"
        >
          <div className="text-xs md:text-sm tracking-[0.3em] uppercase text-[#C5A059] mb-6 font-medium">
            Independent Property Consulting · United Kingdom
          </div>
          <h1
            data-testid="hero-headline"
            className="font-display text-4xl sm:text-5xl lg:text-7xl font-light leading-[1.05] tracking-tight"
          >
            Strategic property consulting
            <br />
            for{" "}
            <span className="italic font-light text-[#F7F3EA]">
              prime London
            </span>{" "}
            landlords.
          </h1>
          <p
            data-testid="hero-subheadline"
            className="mt-8 text-base md:text-lg text-white/85 leading-relaxed max-w-xl font-light"
          >
            Kenneth Nathanael Lukman LLC is a boutique property consultancy
            that curates and oversees premium serviced apartments across the
            United Kingdom on behalf of private owners, family offices and
            investors — combining design, operations and yield strategy into a
            single, calm mandate.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="/consultancy"
              data-testid="hero-cta-explore"
              className="inline-flex items-center justify-center bg-[#6E7F5B] hover:bg-[#5C6B4D] text-white px-8 py-4 rounded-md font-medium tracking-wide transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-black/20"
            >
              Explore Our Services
            </a>
            <button
              type="button"
              onClick={() => openInquiry()}
              data-testid="hero-cta-contact"
              className="inline-flex items-center justify-center bg-white/10 backdrop-blur-md border border-white/40 hover:bg-white hover:text-[#2B3324] text-white px-8 py-4 rounded-md font-medium tracking-wide transition-all duration-300"
            >
              Book a Consultation
            </button>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/70 flex flex-col items-center gap-2"
      >
        <div className="text-[10px] tracking-[0.3em] uppercase">Scroll</div>
        <ChevronDown className="w-4 h-4 animate-bounce" />
      </motion.div>
    </section>
  );
}
